import { gql } from '@urql/vue';

export interface Environment {
  id: string;
  description: string;
}

export const ENVIRONMENTS = gql`
  query {
    environments {
      id
      description
    }
  }
`;
